import { PureComponent } from '../../../../dispatcher/modules';
import React from 'react';
import PuzzleButton from '../PuzzleButton';
import { PUZZLE_COPY_BUTTON_PROPS } from './Types';
import * as _ from 'lodash';

/**
 * PuzzleCopyButton component renders a button for copying content to the clipboard.
 * It provides a customizable button interface with an optional default content.
 */
class PuzzleCopyButton extends PureComponent<PUZZLE_COPY_BUTTON_PROPS> {
  /**
   * Handles copying the value from the specified input field to the clipboard.
   * @returns {void}
   */
  handleCopyValue = () => {
    const { inputValue, onCopy } = this.props;

    if (inputValue) {
      navigator.clipboard.writeText(inputValue);
      onCopy?.();
    }
  };
  render() {
    const {
      buttonText,
      'data-cy': dataCy = 'copyButton',
      themeColor = 'primary',
      fillMode = 'flat',
      size = 'small',
      extraSmall,
      copyButtonPosition
    } = this.props;
    const copyButtonText = buttonText || this.translate('button.copy');

    const copyButtonProps = _.omit(this.props, ['copyButtonPosition', 'buttonText', 'inputValue']);

    return (
      <PuzzleButton
        {...copyButtonProps}
        data-cy={dataCy}
        className={`tp-copy-password-btn ${copyButtonPosition === 'outside' ? 'outside-btn' : ''}`}
        iconClass={'tp-icon tp-content-copy'}
        size={size}
        themeColor={themeColor}
        extraSmall={extraSmall}
        fillMode={fillMode}
        onClick={this.handleCopyValue}
      >
        {copyButtonPosition === 'outside' ? copyButtonText : undefined}
      </PuzzleButton>
    );
  }
}

export default PuzzleCopyButton;
